interface UploadProgressProps {
	progress: number;
	error: boolean;
	onRetry?: () => void;
}

export const UploadProgress: React.FC<UploadProgressProps> = ({
	progress,
	error,
	onRetry,
}) => {
	if (error) {
		return <button onClick={onRetry}>Retry</button>;
	}

	return (
		<progress
			value={progress}
			max={100}
		/>
	);
};
